var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "contact-form",
        attrs: { enctype: "multipart/form-data" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.claimListing($event)
          }
        }
      },
      [
        _c("div", { staticClass: "input-field" }, [
          _c("label", { attrs: { for: "claimant_name" } }, [
            _vm._v("Your Name")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.claim.username,
                expression: "claim.username"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", name: "name", id: "claimant_name" },
            domProps: { value: _vm.claim.username },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.claim, "username", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-field" }, [
          _c("label", { attrs: { for: "claimant_email" } }, [
            _vm._v("Your Email")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.claim.useremail,
                expression: "claim.useremail"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "email", name: "email", id: "claimant_email" },
            domProps: { value: _vm.claim.useremail },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.claim, "useremail", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-field", staticStyle: { "max-height": "43px" } },
          [
            _c(
              "v-app",
              [
                _c("v-autocomplete", {
                  attrs: {
                    loading: _vm.isLoading,
                    "search-input": _vm.search,
                    items: _vm.items,
                    "item-value": function(items) {
                      return items.store_name + " - " + items.store_address
                    },
                    "item-text": function(items) {
                      return items.store_name + " - " + items.store_address
                    },
                    outlined: "",
                    attach: "",
                    dense: "",
                    chips: "",
                    "small-chips": "",
                    label: "Type in store name...",
                    multiple: ""
                  },
                  on: {
                    "update:searchInput": function($event) {
                      _vm.search = $event
                    },
                    "update:search-input": function($event) {
                      _vm.search = $event
                    }
                  },
                  model: {
                    value: _vm.model,
                    callback: function($$v) {
                      _vm.model = $$v
                    },
                    expression: "model"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-field" }, [
          _c("label", { attrs: { for: "message" } }, [_vm._v("Message")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.claim.message,
                expression: "claim.message"
              }
            ],
            staticClass: "materialize-textarea form-control",
            attrs: { type: "text", name: "message", id: "message", rows: "10" },
            domProps: { value: _vm.claim.message },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.claim, "message", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-field" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary waves-effect waves-light",
          attrs: { type: "submit" }
        },
        [_vm._v("Send")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6017ac5f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6017ac5f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ClaimListing.vue
// module id = 65
// module chunks = 1